import * as React from 'react';
import {Checkbox} from '@sail/ui';

export const Uncontrolled = () => {
  return (
    <Checkbox
      onChange={(e) => {
        /* eslint-disable no-console */
        console.log(e.target.checked);
      }}
      defaultChecked
      label="This Checkbox is uncontrolled."
    />
  );
};
